export default __webpack_public_path__ + "static/media/Licenses_IMG-QA-03.493cc159.png";